export default __webpack_public_path__ + "static/media/HeroDark.88e9d107.svg";